import { OnboardingView } from '../components/onboarding';

/**
 * `/onboarding` — the role-based onboarding surface (spec §8.1, §10.4).
 *
 * A single screen rather than a nested router: which path is open is a query
 * parameter (`?path=…`) on this one route, so returning to the overview never
 * leaves the onboarding context and the browser's back button walks the path
 * history the user actually made.
 */
export function OnboardingPage() {
  return <OnboardingView />;
}

export default OnboardingPage;
